import { KikCrypto } from "@kikocosmeticsorg/uc-api-nest-common-fe";

import { StorageFactory } from "~/services/storage.factory";
import { CacheKeys } from "~/shared/cache-keys";

export class CorrelationId {
  protected static _storage = new StorageFactory<CacheKeys>("sessionStorage");

  // One correlation id per browser session; SSR has no session to persist it in, so each request gets its own.
  static get(): string {
    if (typeof window === "undefined") {
      return KikCrypto.generateCorrelationId();
    }

    const existingCorrelationId = this._storage.get(CacheKeys.CORRELATION_ID);
    if (existingCorrelationId) {
      return existingCorrelationId;
    }

    const correlationId = KikCrypto.generateCorrelationId();
    this._storage.set(CacheKeys.CORRELATION_ID, correlationId);

    return correlationId;
  }
}
